import { render } from "./g-turnstile-field.vue?vue&type=template&id=007d12f3&ts=true"
import script from "./g-turnstile-field.vue?vue&type=script&lang=tsx"
export * from "./g-turnstile-field.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__